// vc-cart.js — Valerie Confections cart UX helpers (site-wide, single-run)
(() => {
  if (window.__vcCartOnce) return;
  window.__vcCartOnce = true;

  /* ---------- Config: blocked dates (YYYY-MM-DD) ---------- */
  const blackoutDates = [
    '2025-11-27', // Thanksgiving
    '2025-11-28', // Black Friday
    '2025-12-22', // Christmas Week
    '2025-12-23', // Christmas Week
    '2025-12-24', // Christmas Eve
    '2025-12-25', // Christmas
    '2025-12-26', // Boxing Day
    '2026-01-01', // New Year's Day
    '2026-01-02'  // Day After New Year's Day
  ];

  /* ---------- Helpers for inline help/error message ---------- */
  const DEFAULT_HELP =
    'We’ll do our best to meet this date. We cannot deliver on Sundays, Mondays, or Holidays.';

  function setHelpMessage(msg, isError) {
    const help = document.getElementById('vc-date-help');
    if (!help) return;
    if (msg) {
      help.textContent = msg;
      help.setAttribute('data-state', isError ? 'error' : 'info');
      help.setAttribute('role', 'alert');
      help.setAttribute('aria-live', 'polite');
    } else {
      help.textContent = DEFAULT_HELP;
      help.removeAttribute('data-state');
      help.removeAttribute('role');
      help.removeAttribute('aria-live');
    }
  }

  /* ---------- Date picker binding ---------- */
  function setMinDate(input, leadDays) {
    const d = new Date();
    d.setDate(d.getDate() + (leadDays || 3)); // default to 3-day lead time
    input.min = d.toISOString().split('T')[0];
  }

  // Parse "YYYY-MM-DD" safely and get weekday in UTC (avoids DST/timezone issues)
  function parseISOToUTCDay(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!m) return { valid: false, day: null };
    const y = Number(m[1]), mo = Number(m[2]) - 1, d = Number(m[3]);
    const dt = new Date(Date.UTC(y, mo, d, 12, 0, 0)); // UTC noon
    if (isNaN(dt)) return { valid: false, day: null };
    return { valid: true, day: dt.getUTCDay() }; // 0=Sun ... 6=Sat
  }

  function validateAndMaybeClear(el) {
    if (!el.value) {
      el.setCustomValidity('');
      setHelpMessage(null, false);
      el.removeAttribute('aria-invalid');
      return true;
    }

    const iso = el.value;
    const { valid, day } = parseISOToUTCDay(iso);
    if (!valid) {
      el.setCustomValidity('');
      setHelpMessage(null, false);
      el.removeAttribute('aria-invalid');
      return true;
    }

    let msg = '';
    if (day === 0 || day === 1) {
      msg = 'We cannot deliver on Sundays or Mondays. Please choose another date.';
    } else if (blackoutDates.includes(iso)) {
      msg = 'We cannot deliver on this date. Please select another.';
    }

    if (msg) {
      el.setCustomValidity(msg);
      setHelpMessage(msg, true);
      el.setAttribute('aria-invalid', 'true');

      // iOS often suppresses native bubbles; clear and attempt to show
      el.value = '';
      if (typeof el.reportValidity === 'function') el.reportValidity();
      return false;
    } else {
      el.setCustomValidity('');
      setHelpMessage(null, false);
      el.removeAttribute('aria-invalid');
      return true;
    }
  }

  function bindVCDate() {
    const input = document.getElementById('vc-delivery-date');
    if (!input || input.__vcBound) return;
    input.__vcBound = true;

    setMinDate(input, 3); // enforce 3-day lead time
    setHelpMessage(null, false);

    // iOS reliability: listen to input, change, and blur
    const handler = (e) => validateAndMaybeClear(e.target);
    input.addEventListener('input', handler);
    input.addEventListener('change', handler);
    input.addEventListener('blur', handler);

    input.addEventListener('change', (e) => {
      if (!validateAndMaybeClear(e.target)) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { 'Desired date': e.target.value } })
      })
      .then(r => r.json())
      .then(() => document.dispatchEvent(new CustomEvent('cart:refresh')))
      .catch(err => console.error('Date save failed', err));
    });
  }
  // Expose in case you want to call it from HTML
  window.bindVCDate = bindVCDate;

  /* ---------- (Optional) Accordion animation ---------- */
  function bindAccordionAnimation() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('details.cart-accordion').forEach(details => {
      if (details.__vcAnimBound) return;
      details.__vcAnimBound = true;

      const content = details.querySelector('.cart-accordion__content');
      if (!content) return;

      function collapse() {
        const h = content.scrollHeight;
        content.style.overflow = 'hidden';
        content.style.maxHeight = h + 'px';
        requestAnimationFrame(() => { content.style.maxHeight = '0px'; });
      }
      function expand() {
        content.style.overflow = 'hidden';
        content.style.maxHeight = '0px';
        requestAnimationFrame(() => {
          const h = content.scrollHeight;
          content.style.maxHeight = h + 'px';
        });
      }
      content.addEventListener('transitionend', () => {
        if (!details.open) { content.style.maxHeight = ''; content.style.overflow = ''; }
        else { content.style.maxHeight = 'none'; content.style.overflow = ''; }
      });
      details.addEventListener('toggle', () => {
        content.style.transition = 'max-height .22s ease';
        details.open ? expand() : collapse();
        setTimeout(bindVCDate, 0); // ensure date binds when opened
      });
    });
  }

  /* ---------- Header duplicate safety (mobile) ---------- */
  function dedupeHeaderNav() {
    const menus = document.querySelectorAll('.header__inline-menu');
    if (menus.length > 1) {
      for (let i = 1; i < menus.length; i++) menus[i].remove();
    }
  }

  /* ---------- Bind on common events ---------- */
  function bindAll() {
    bindVCDate();
    bindAccordionAnimation();
    dedupeHeaderNav();
  }

  document.addEventListener('DOMContentLoaded', bindAll);
  document.addEventListener('cart:refresh', () => setTimeout(bindAll, 50));
  document.addEventListener('shopify:section:load', () => setTimeout(bindAll, 50));
  window.addEventListener('pageshow', bindAll);
})();
